export function simulateInvestment({ initial, monthly, years, annualRate }) {
  if (![initial, monthly, years, annualRate].every(Number.isFinite) || initial < 0 || monthly < 0 || initial > 1000000000 || monthly > 10000000 || years < 1 || years > 50 || !Number.isInteger(years) || annualRate <= -100 || annualRate > 100) return null;
  const rate = (1 + annualRate / 100) ** (1 / 12) - 1;
  let balance = initial;
  const points = [{ year: 0, balance, principal: initial }];
  for (let month = 1; month <= years * 12; month += 1) {
    balance = balance * (1 + rate) + monthly;
    if (month % 12 === 0) points.push({ year: month / 12, balance, principal: initial + monthly * month });
  }
  const principal = initial + monthly * years * 12;
  return { balance, principal, gain: balance - principal, points };
}
